// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLeaveUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_4564_301557)">
					<path
						d="M15.71 12.8501V13.7901L15.97 14.1201H19.41L19.76 13.6201L19.67 12.8501H15.71Z"
						fill="#EAC306"
					/>
					<path
						d="M6.45999 18.5199H14.47C14.6 18.5199 14.71 18.3999 14.71 18.2499V16.9299C14.71 16.6299 14.62 16.5099 14.46 16.2799L12.69 13.9699C12.27 13.3799 12.28 12.5399 12.71 11.9599L13.15 11.3699C13.28 11.1999 13.17 10.9299 12.97 10.9299H8.01999C7.81999 10.9299 7.70999 11.1899 7.83999 11.3699L8.27999 11.9599C8.70999 12.5399 8.70999 13.3799 8.29999 13.9699L6.48999 16.2799C6.32999 16.5099 6.23999 16.6399 6.23999 16.9299V18.2499C6.23999 18.3999 6.34999 18.5199 6.47999 18.5199H6.45999Z"
						fill="#EAC306"
					/>
					<path
						d="M15.36 18.59V17.08C15.36 16.69 15.22 16.31 14.98 16L12.8 13.33C12.62 13.1 12.62 12.78 12.8 12.55L14.98 9.87999C15.23 9.57999 15.36 9.18999 15.36 8.79999V7.27999C15.72 7.03999 15.93 6.63999 15.93 6.20999V5.63999C15.93 5.27999 15.64 4.98999 15.28 4.98999H5.65C5.29 4.98999 5 5.27999 5 5.63999V6.20999C5 6.63999 5.22 7.03999 5.57 7.27999V8.79999C5.57 9.18999 5.71 9.56999 5.95 9.87999L8.13 12.55C8.31 12.78 8.31 13.1 8.13 13.33L5.95 16C5.7 16.3 5.57 16.69 5.57 17.08V18.61C5.22 18.85 5.01 19.24 5.01 19.67V20.24C5.01 20.6 5.3 20.89 5.66 20.89H15.29C15.65 20.89 15.94 20.6 15.94 20.24V19.67C15.94 19.24 15.71 18.83 15.35 18.6L15.36 18.59ZM15.15 19.66V20.09H5.81V19.66C5.81 19.39 6.03 19.18 6.29 19.18H14.67C14.94 19.18 15.15 19.4 15.15 19.66ZM6.21 6.69999C5.97 6.66999 5.8 6.45999 5.8 6.21999V5.78999H15.14V6.21999C15.14 6.45999 14.96 6.66999 14.74 6.69999H6.21ZM8.76 12.05L6.58 9.37999C6.45 9.21999 6.38 9.00999 6.38 8.80999V7.50999H14.57V8.80999C14.57 9.01999 14.5 9.21999 14.37 9.37999L12.19 12.05C11.77 12.57 11.77 13.32 12.19 13.84L14.37 16.51C14.5 16.67 14.57 16.88 14.57 17.08V18.39H6.37V17.08C6.37 16.87 6.44 16.67 6.57 16.51L8.75 13.84C9.17 13.32 9.17 12.57 8.75 12.05H8.76Z"
						fill="black"
					/>
					<path
						d="M20.06 17.95V17.35C20.06 17.13 19.98 16.91 19.85 16.74L18.95 15.51C18.95 15.51 18.93 15.43 18.95 15.39L19.84 14.17C19.98 14 20.06 13.77 20.06 13.55V12.94C20.22 12.79 20.31 12.58 20.31 12.36V11.73C20.31 11.45 20.09 11.23 19.82 11.23H15.5C15.23 11.23 15.01 11.45 15.01 11.73V12.36C15.01 12.59 15.11 12.8 15.27 12.95V13.55C15.27 13.77 15.35 13.99 15.48 14.17L16.4 15.4C16.4 15.4 16.42 15.48 16.4 15.51L15.49 16.73C15.35 16.9 15.27 17.13 15.27 17.35V17.95C15.11 18.1 15.01 18.31 15.01 18.54V19.17C15.01 19.45 15.23 19.67 15.5 19.67H19.82C20.09 19.67 20.31 19.45 20.31 19.17V18.54C20.31 18.31 20.22 18.1 20.05 17.95H20.06ZM15.76 11.99H19.54V12.38H15.77C15.77 12.38 15.75 12.38 15.75 12.36V12L15.76 11.99ZM16.99 14.92L16.07 13.69C16.07 13.69 16.02 13.6 16.02 13.55V13.15H19.29V13.55C19.29 13.6 19.27 13.65 19.24 13.7L18.35 14.92C18.1 15.23 18.1 15.68 18.35 15.99L19.25 17.22C19.25 17.22 19.3 17.31 19.3 17.36V17.76H16.03V17.36C16.03 17.31 16.05 17.26 16.08 17.22L16.99 16C17.24 15.69 17.24 15.24 16.99 14.93V14.92ZM19.55 18.52V18.9H15.75V18.52H19.55Z"
						fill="black"
					/>
					<path d="M13.6699 10.3201H7.15991V11.0601H13.6699V10.3201Z" fill="black" />
					<path d="M19.41 13.75H15.97V14.12H19.41V13.75Z" fill="black" />
				</g>
				<defs>
					<clipPath id="clip0_4564_301557">
						<rect width={15.32} height={15.89} fill="white" transform="translate(5 5)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgLeaveUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLeaveUnique24;
